module.exports = __webpack_public_path__ + "img/empty-team.14c754b8.png";